<template>
    <div>
        <div v-if="!selectedFridge">
            Холодильник не выбран
        </div>
        <div v-if="selectedFridge">
            <last-error-block></last-error-block>

            <div class="status-block">
                <div v-if="isWaitingAnswer">
                    Ожидание первого ответа...
                </div>

                <table v-if="!!scalesArray.length" class="table table-sm scales-table">
                    <tr>
                        <th>Адрес / название</th>
                        <th>Значение</th>
                    </tr>

                    <tr v-for="scales in scalesArray">
                        <td>
                            <div>
                                {{scales.address}}
                            </div>
                            <div v-if="!!scales.title.length" class="scales-title">
                                {{scales.title}}
                            </div>
                        </td>
                        <td>
                            <div v-if="scales.error !== false" class="scales-error">
                                {{scales.error}}
                            </div>
                            <div v-if="scales.error === false">
                                {{scales.weight}}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import fridgeRabbit from "../utils/rabbit/fridge_rabbit";
    import LastErrorBlock from "../components/LastErrorBlock";


    export default {
        name: "TestScales",
        components: {LastErrorBlock},
        computed: {
            ...mapState('app', {
                selectedFridge: 'selectedFridge',
            }),
            isWaitingAnswer() {
                return this.response === null;
            },
            scalesArray() {
                return this.response && this.response.scales ? this.response.scales : [];
            },
        },
        methods: {
            ...mapActions('app', {
                setLastError: 'setLastError',
                clearLastError: 'clearLastError',
            }),
            checkScales() {
                this.response = null;
                fridgeRabbit.send('check_scales');
            },
            onAnswer(data) {
                if(!data) {
                    return;
                }

                if(!data.success) {
                    this.setLastError(data.error);
                } else {
                    this.clearLastError();
                }

                this.response = data;
            },
        },
        data() {
            return {
                response: null,
            };
        },
        async mounted() {
            await fridgeRabbit.listen(this.onAnswer);
            this.checkScales();
        },
        destroyed() {
            fridgeRabbit.clear();
            this.clearLastError();
        },
    }
</script>

<style scoped>
    .scales-table {
        font-size: 0.9em;
    }
    .scales-title {
        font-size: 0.8em;
    }
    .scales-error {
        color: red;
    }
</style>
